const nodeEnv = process.env.NODE_ENV;

// CRA only exposes development or production in the browser bundle.
// On `npm run build`, NODE_ENV is always "production". Staging vs production
// is controlled by REACT_APP_API_ENDPOINT at build time — CRA loads
// web/.env.production.local first (if present), then .env.production, then .env.
export const URL = nodeEnv === 'production'
  ? (process.env.REACT_APP_API_ENDPOINT || 'https://passport.esnlisboa.org')
  : (process.env.REACT_APP_API_ENDPOINT_DEV || 'http://localhost:3001');

export const reCaptchaKey = "6Lc4C8MbAAAAAOl9FcpYe5guS-SFFuf4t8tLmzmu";